<template>
  <div>
    <div class='cusLayer full' id='cart'>
      <!-- 상단 Header -->
      <div class='cusHd'>
        <div class='row'>
          <div class='col col1'>
            <!-- <span v-if='tableNo && tableNo > 0' class='tbNum'><em>테이블</em><em>{{tableNo}}</em></span> -->
          </div>
          <div class='col col2'><h1 class='tit'>{{$t('cart')}}</h1></div>
          <div class='col col3'>
            <button type='button' class='btnCloseModal' @click='onClickCloseBtn'>
              {{$t('close')}}
            </button>
          </div>
        </div>
      </div>
      <!-- 카트 리스트 -->
      <div class="cusCnt" v-if="appFlag">
        <div v-if="appCartLength > 0">
          <div class="appCartTop">
            <div class="orderTag" v-if="qrType == 0">{{$t('orderInStore')}}</div>
            <div class="orderTag" v-else-if="qrType == 1">{{$t('orderForDelivery')}}</div>
            <div style="display: flex; align-items: center; padding-top:12px; width: 100%">
              <div class="cartStoreImg" v-if="imagePath"><img :src="imagePath"></div>
              <div class="cartStoreImg" v-else><img src="../../assets/img/list_img_empty.png" alt=""></div>
              <div class="d-flex flex-space-between w100p flex-x-center" @click="storeIntroUrl">
                <div>
                  <div class="cartStoreName">
                    <p>{{cartStoreName}}</p>
                    <div class="arrow"></div>
                  </div>
                  <div class="marketName" v-if="marketName">{{marketName}}</div>
                </div>
                <div class="cartTableNum" v-if="tableNo && tableNo >= 0">{{$t('Cart.table')}} {{tableNo}}</div>
              </div>
            </div>
          </div>
          <div class="cartList" v-for="(cartList,index) in cartInfo" :key="index">
            <div class="cartContentTop">
              <div class="cartMenuName">
                <MenuName :menu='cartList.menu' :mainFlag='1'>
                  <strong>{{cartList.menu.name}}</strong>
                </MenuName>
              </div>
              <div class="cartDelBtnLine"></div>
              <div class="cartDelBtn" @click="cartDelete(index)"></div>
            </div>
            <div class="cartContentMid">
              <div class="cartOption">기본</div>
              <div class="cartOptionPrice">{{formatComma(cartList.menu.price)}}원</div>
            </div>
            <div class="cartDetailOption">
              <li v-for='option in cartList.menu.option' :key='option.menuOptionCode'>
                <strong>{{option.detailOption.menuDetailOptionName}}</strong>
                <span>{{formatComma(option.detailOption.price)}}{{$t('MoneyUnit')}}</span>
              </li>
              <!-- 추가 옵션 -->
              <li v-for='option in cartList.menu.additionalOption' :key='option.menuOptionCode'>
                <strong>{{option.menuOptionName}}</strong>
                <span>{{formatComma(option.price)}}{{$t('MoneyUnit')}}</span>
              </li>
              <!-- 선택 옵션 -->
              <li v-for='(option, idx) in cartList.menu.optionalOption' :key='idx'>
                <strong>{{option.detailOption.menuDetailOptionName}}</strong>
                <span>{{formatComma(option.detailOption.price)}}{{$t('MoneyUnit')}}</span>
              </li>
            </div>
            <div class="cartContentBot">
              <div class="cartMenuCountBtn">
                <div :class="cartList.count == 1 ? 'disabledMenuCountMinusBtn' : 'menuCountMinusBtn'" @click="cartUpdate(index,1)"></div>
                <div class="menuCountBtnNum">{{cartList.count}}</div>
                <div class="menuCountPlusBtn" @click="cartUpdate(index,2)"></div>
              </div>
              <div class="cartMenuPrice">{{formatComma(cartList.price * cartList.count)}}<span>원</span></div>
            </div>
          </div>
        </div>
        <!-- 카트에 상품이 하나도 없을 때 -->
        <div v-else class='noData'>
          <div class='in'><p>{{$t('emptyCart')}}</p></div>
        </div>
      </div>

      <div class='cusCnt' v-else>
        <div class="cartTop">
            <div class="orderTag" v-if="qrType == 0">{{$t('orderInStore')}}</div>
            <div class="orderTag" v-else-if="qrType == 1">{{$t('orderForDelivery')}}</div>
            <div style="display: flex; align-items: center; padding-top:12px; width: 100%">
              <div class="cartStoreImg" v-if="imagePath"><img :src="imagePath"></div>
              <div class="cartStoreImg" v-else><img src="../../assets/img/list_img_empty.png" alt=""></div>
              <div class="d-flex flex-space-between w100p flex-x-center" @click="storeIntroUrl">
                <div>
                  <div class="cartStoreName">
                    <p>{{cartStoreName}}</p>
                    <div class="arrow"></div>
                  </div>
                  <div class="marketName" v-if="marketName">{{marketName}}</div>
                </div>
                <div class="cartTableNum" v-if="tableNo && tableNo >= 0">{{$t('Cart.table')}} {{tableNo}}</div>
              </div>
            </div>
          </div>
        <div v-if='cartMenuNo > 0 && cart' class='in'>
          <ul class='orderList cart'>
            <li v-for='storeCode in Object.keys(cart).reverse()' :key='storeCode' class='li '>
              <CartItem
                v-for='menuCode in Object.keys(cart[storeCode]).reverse()'
                :key='menuCode'
                :menu='cart[storeCode][menuCode]'
                :menuCode='menuCode'
                @changeCount='changeCount'
                @delMenu='delMenu'/>
            </li>
          </ul>
        </div>
        <!-- 카트에 상품이 하나도 없을 때 -->
        <div v-else class='noData'>
          <div class='in'><p>{{$t('emptyCart')}}</p></div>
        </div>
      </div>
      <!-- 주문하기 버튼 -->
      <div v-if='appFlag ? appCartLength > 0 : cartMenuNo > 0' class='cusBtm cart'>
        <!-- TODO : 2025-12-10 명동 포장 관련 임시 , !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode) 조건 삭제 -->
        <div class="cartMinOrderFee" v-if="!isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">
          <p v-if="this.$i18n.locale==='cn'"><span>{{formatComma(cartMinOrderFee)}}</span> {{$t('Cart.minimumCost')}}</p>
          <p v-else-if="this.$i18n.locale==='en'">{{$t('Cart.minimumCost')}} <span>{{formatComma(cartMinOrderFee.minOrderFee)}}</span></p>
          <p v-else>{{$t('Cart.minimumCost')}} <span>{{formatComma(cartMinOrderFee)}}원</span></p>
        </div>
        <button type='button' class='btn price order' @click='order'>
          <span>{{$t('totalPay')}}</span>
          <span class='num'>{{appFlag ? formatComma(appTotalPrice) : formatComma(totalPrice)}}</span>
          <!-- TODO : 2025-12-10 명동 포장 관련 임시 , 아래 주석 풀고 -->
          <!--          <span v-if="this.$i18n.locale==='ko'">원 결제하기</span>-->
          <!-- TODO : 2025-12-10 명동 포장 관련 임시 , 아래 두줄 삭제 -->
          <span v-if="this.$i18n.locale==='ko' && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">원 결제하기</span>
          <span v-else-if="this.$i18n.locale==='ko' && isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">원 포장 결제하기</span>
          <span v-else>{{$t('MoneyUnit')}}</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script lang="js">
import CartItem from '@/components/Common/CartItem.vue'
import MenuName from '@/components/Common/MenuName.vue'
import { CHANGE_CART, SET_DIRECTFLAG } from '@/store/_actions/actionTypes'
import { CART_POPUP } from '@/utils/EndPoint'
import { addCart } from '@/utils/Methods'
import { THROW_ORDER } from '@/router'
import service from '@/backend/modnpay_app_api'
import Vue from 'vue'
export default Vue.extend({
  name: CART_POPUP,
  props: ['cart', 'extraMenu', 'cartInfo', 'appTotalPrice', 'cartStoreName', 'cartStoreCode', 'marketName', 'qrType', 'cartMinOrderFee'], // 원본 카트
  components: { CartItem, MenuName },
  data () {
    return {
      tableNo: this.$store.getters.tableNo, // 테이블 번호
      menuNo: 0,
      price: 0
    }
  },
  computed: {
    stores () { return this.$store.getters.stores },
    currentStoreCode () { return this.$store.getters.currentStoreCode },
    changeVuexFlag () { return this.$store.getters.changeVuexFlag },
    cartNo () { return this.$store.getters.cartMenuNo }, // 카트에 담긴 상품 개수
    cartPrice () { return this.$store.getters.totalPrice }, // 카트에 담긴 상품 총 가격
    imagePath () { return this.$store.getters.cartImagePath },
    appCartLength () { return this.cartInfo ? this.cartInfo.length : 0 },
    cartMenuNo () {
      return this.changeVuexFlag ? this.cartNo : this.menuNo
    },
    totalPrice () { return this.changeVuexFlag ? this.cartPrice : this.price }
  },
  watch: {
    extraMenu () {
      const menuCount = this.extraMenu.menu.count
      const menuPrice = this.extraMenu.menu.originPrice
      addCart(this.cart, this.extraMenu)
      this.menuNo = this.cartNo + menuCount
      this.price = this.cartPrice + (menuCount * menuPrice)
    }
  },
  beforeDestroy () {
    this.removePopUp()
  },
  methods: {
    async cartDelete (index) {
      const req = {
        appCartId: this.cartInfo[index].appCartId
      }
      const { data } = await service.appCartDelete(req)
      if (data.resultCode == 0) {
        this.$emit('cartList', this.cartInfo)
      }
    },
    async cartUpdate (index, countType) {
      if (countType === 1 && this.cartInfo[index].count > 1) {
        this.cartInfo[index].count--
      } else if (countType === 2) {
        this.cartInfo[index].count++
      }
      const req = {
        appCartId: this.cartInfo[index].appCartId,
        cartInfo: JSON.stringify(this.cartInfo[index]),
        count: this.cartInfo[index].count
      }
      const { data } = await service.appCartUpdate(req)
      if (data.resultCode == 0) {
        this.$emit('cartList')
      }
    },
    delMenu (menu, menuCode) { // 상품 삭제
      delete this.cart[menu.storeCode][menuCode]
      // cart menu count와 total price 변경
      this.changeCount(menu.count * -1, menu.count * menu.originPrice * -1)
    },
    changeCount (count, price) { // 상품 개수 변경
      // 실제 카트 데이터 변경
      if (this.changeVuexFlag) {
        this.$store.dispatch(CHANGE_CART, { cartMenuNo: count, totalPrice: price })
      } else {
        this.menuNo += count
        this.price += price
      }
    },
    onClickCloseBtn () {
      this.removePopUp()
      this.$emit('cartFlagChange')
    },
    async storeIntroUrl () {
      const req = {
        urlCode: this.cartStoreCode,
        introUrlType: this.qrType
      }
      const { data } = await service.storeIntroUrl(req)
      sessionStorage.removeItem('tradition')
      sessionStorage.removeItem('categoryCode')
      sessionStorage.removeItem('addressByLotNum')
      sessionStorage.removeItem('time')
      window.location.href = data.introUrl
    },
    order () { // 결제하기 버튼 클릭
      if (this.appFlag) {
        // if (this.$store.getters.storeGroupCode == this.cartInfo[0].menu.storeCode) {
        if (this.cartInfo) {
          localStorage.setItem('pageType', 1)
          sessionStorage.setItem('cartInfo', JSON.stringify(this.cartInfo))
          sessionStorage.setItem('totalPrice', this.totalPrice)
          this.storeIntroUrl()
          // this.$router.push({ name: 'ORDER' })
          // THROW_ORDER(this.cartInfo, this.totalPrice)
        }
        // } else {
        //   this.toastBottom(this, '다른 매장의 상품이 포함되어 있습니다.')
        // }
      } else {
        THROW_ORDER(this.cart, this.totalPrice)
      }
    }
  }
})
</script>
